const WhatAreYouLookingForContentType = {
	FirstOptions:'first-options'
};
export default WhatAreYouLookingForContentType;